<section class="content-image">

    <div
        class="container-redesign">

        <div
            class="content-image__wrapper"
            [class.content-image__wrapper--reverse]="!imageLeft">

            <div class="content-image__image">

                <img
                    [src]="image"
                    [alt]="imageAlt">

            </div>

            <div class="content-image__content">

                <h2 class="content-image__title">

                    {{ title }}

                </h2>

                <p
                    *ngFor="let paragraph of paragraphs; trackBy: trackByIndex"
                    class="content-image__paragraph">

                    {{ paragraph }}

                </p>

            </div>

        </div>

    </div>

</section>